import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[appTrim]',
	standalone: false,
})
export class TrimDirective {
	constructor(private element: ElementRef) {}

	@HostListener('blur') onBlur(): void {
		const value = this.element.nativeElement.value;
		this.element.nativeElement.value = value.trim();
	}
}
